import React, { FC } from 'react';

type Props = {
  children: React.ReactNode;
};
const ChangeValueDataCell: FC<Props> = ({ children }) => {
  return (
    <td className="tw-px-3 tw-py-2">
      <p className="tw-flex tw-items-center tw-gap-2 tw-text-md tw-font-regular">
        {children}
      </p>
    </td>
  );
};

export default ChangeValueDataCell;
